interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="py-16 md:py-20 flex flex-col items-center text-center px-4">
      <span className="w-16 h-16 rounded-full bg-background-100 text-background-400 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="font-heading font-bold text-base md:text-lg text-foreground-800">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 h-10 px-5 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}